import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { PaginationDispatch } from './reducers/pagination'
import paginationReducer, { PaginationState, initialPaginationState } from './reducers/pagination'

type Context = [PaginationState, PaginationDispatch]

const { context: PaginationContext, hook: usePagination } = createContext<Context>()

const PaginationProvider = ({ children }: React.PropsWithChildren<object>) => {
  const memoizedReducer = useCallback(paginationReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialPaginationState())

  return (
    <PaginationContext.Provider value={[state, dispatch]}>{children}</PaginationContext.Provider>
  )
}

export { PaginationProvider, usePagination }
